const productFields = ['product_category_1', 'product_category_2'];
const urlParams = new URLSearchParams(window.location.search);

const parameters = {
  product_category: 'All',
  title: '',
};
let shouldUpdate = false;

Object.keys(parameters).forEach((key) => {
  if (urlParams.has(key, parameters[key])) {
    shouldUpdate = true;
    urlParams.delete(key, parameters[key]);
  }
});

// Update the browser's URL.
if (shouldUpdate) {
  const queryString = urlParams.toString();
  const resetBtn = document.getElementById('edit-reset');

  if (resetBtn) {
    resetBtn.disabled = queryString === '';
  }

  const newUrl = `${window.location.pathname}${
    urlParams.toString() !== '' ? `?${urlParams.toString()}` : ''
  }`;
  window.history.replaceState(null, '', newUrl);
}

productFields.forEach((field) => {
  // Check if the parameter exists in the URL
  // if not, then unselect the first val
  // as it is being selected by default.
  if (!urlParams.has(field)) {
    const editField = document.getElementById(
      `edit-${field.replaceAll('_', '-')}`,
    );
    if (editField) {
      editField.selectedIndex = -1;
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const formProductCatalog = document.getElementById(
    'views-exposed-form-product-catalog-product-catalog-page',
  );

  formProductCatalog
    ?.querySelector('#edit-reset')
    ?.addEventListener('click', (event) => {
      event.preventDefault();
      const retainList = ['product_category'];

      // eslint-disable-next-line no-restricted-syntax
      for (const key of [...urlParams.keys()]) {
        if (!retainList.includes(key)) {
          urlParams.delete(key);
        }
      }

      let location = window.location.href.split('?')[0];
      if (urlParams.toString() !== '') {
        location += `?${urlParams.toString()}`;
      }
      window.location.href = location;
    });
});
